import cn from "./cn";

/**
 * Surface — the one in-page work surface (DESIGN.md › Elevation & Depth,
 * Panels and cards): white, hairline border, panel radius, and the panel
 * elevation from the token layer. Use it for a real work region — a table
 * with its toolbar, a queue, a grouped form, an object card — never to box a
 * single label, number or sentence. `toolbar` sits above the content inside
 * the same surface, so filters and the list they filter read as one region.
 */
export default function Surface({ as: Component = "div", toolbar, padded = false, className, children, ...props }) {
  return (
    <Component data-ui="surface" className={cn("rounded-panel border border-default bg-surface", padded && "p-4", className)} {...props}>
      {toolbar ? <div data-ui="surface-toolbar" className="border-b border-subtle px-4 py-3">{toolbar}</div> : null}
      {children}
    </Component>
  );
}
